import { createHashRouter, RouterProvider } from "react-router-dom";
import store from "./util/store";
import { MapOverview } from "./presenters/mapOverviewPresenter";
import { Home } from "./presenters/homePresenter";
import { Login } from "./presenters/loginPresenter";
import { ForgotPassword } from "./presenters/forgotPasswordPresenter";
import { SignUp } from "./presenters/signUpPresenter";
import { Profile } from "./presenters/profilePresenter";
import { ArrivalCheck } from "./presenters/arrivalCheckPresenter";
import { ModeSelection } from "./presenters/modeSelectionPresenter";
import { MindSnap } from "./presenters/mindSnapPresenter";
import { TravelInfo } from "./presenters/travelInfoPresenter";
import {ProtectedRoute} from "./util/protectedRoute";
import { FactFiction } from "./presenters/factFictionPresenter";
import { MirrorShot } from "./presenters/mirrorShotPresenter";
import { SpeechBubble } from "./presenters/speechBubblePresenter";
import { NotArrived } from "./presenters/notArrivedPresenter";
import { TimelineScramble } from "./presenters/timelineScramblePresenter";
import { CheckPointInfo } from "./presenters/checkPointInfoPresenter";
import { QuestComplete } from "./presenters/questCompletePresenter";
import {AboutUs} from "./presenters/aboutsUsPresenter"
import { AskAIGame } from "./presenters/askAIGamePresenter";
import { CheckpointList } from "./presenters/checkpointListPresenter";

const ReactRoot = () => {
  function makeRouter() {
      return createHashRouter([
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/login",
          element: <Login />,
        },
        {
          path: "/about",
          element: <AboutUs />,
        },
        {
          path: "/signup",
          element: <SignUp />,
        },
        {
          path:"/forgotpassword",
          element: <ForgotPassword />,
        },
        {
          path: "/profile",
          element: (
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          ),
        },
        {
          path: "/mapOverview",
          element: (
            <ProtectedRoute>
              <MapOverview />
            </ProtectedRoute>
          ),
        },
        {
          path: "/arrivalCheck/:id",
          element: (
            <ProtectedRoute>
              <ArrivalCheck />
            </ProtectedRoute>
          ),
        },
        {
          path: "/modeSelection/:id",
          element: (
            <ProtectedRoute>
              <ModeSelection />
            </ProtectedRoute>
          ),
        },
        {
          path: "/mindSnap/:id/:mode/",
          element: (
            <ProtectedRoute>
              <MindSnap />
            </ProtectedRoute>
          ),
        },
        {
          path: "/askAIGame/:id/:mode/",
          element: (
            <ProtectedRoute>
              <AskAIGame/>
            </ProtectedRoute>
          ),
        },
        {
          path: "/factFiction/:id/:mode/",
          element: (
            <ProtectedRoute>
              <FactFiction />
            </ProtectedRoute>
          ),
        },
        {
          path: "/mirrorShot/:id/:mode/",
          element: (
            <ProtectedRoute>
              <MirrorShot />
            </ProtectedRoute>
          ),
        },
        {
          path: "/speechBubble/:id/:mode/",
          element: (
            <ProtectedRoute>
              <SpeechBubble />
            </ProtectedRoute>
          ),
        },
        {
          path: "/timelineScramble/:id/:mode",
          element: (
            <ProtectedRoute>
              <TimelineScramble />
            </ProtectedRoute>
          ),
        },
        {
          path: "/travelInfo/:id/:mode",
          element: (
            <ProtectedRoute>
              <TravelInfo />
            </ProtectedRoute>
          ),
        },
        {
          path: "/notArrived/:id",
          element: (
            <ProtectedRoute>
              <NotArrived />
            </ProtectedRoute>
          ),
        },
        {
          path:"/checkpoint/:id",
          element:(
            <ProtectedRoute>
              <CheckPointInfo/>
            </ProtectedRoute>
          )
        },
        {
          path: "/questComplete/:id/:mode/:questType",
          element: (
            <ProtectedRoute>
              <QuestComplete />
            </ProtectedRoute>
          ),
        },
        {
          path: "/checkpointList",
          element: (
            <ProtectedRoute>
              <CheckpointList />
            </ProtectedRoute>
          ),
        },
      ]);
    }
  
  return (
    <div>
      <RouterProvider router={makeRouter()} />
    </div>
  );
};

export { ReactRoot };
